import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { useLanguage } from '../../hooks/useLanguage';

const Categories = () => {
  useTranslation();
  const { getLocalizedPath } = useLanguage();

  const categories = [
    'Mastics / Putties',
    'Degreasers',
    'Abrasives',
    'Fillers / Apprêts',
    'Ready Mix / Finished Paint',
    'Masking Products',
    'Primers',
    'Stone Chip Protectors',
    'Miscellaneous / Accessories',
    'Varnishes / Clearcoats',
    'Sealants',
    'Paint Equipment / Tools',
    'Thinners / Reducers',
    'Spray Products / Aerosols',
    'Base Coats (Color Mixing System)',
  ];

  const slugify = (s) =>
    s
      .toLowerCase()
      .replace(/\s*\(.*?\)\s*/g, '')
      .replace(/\s*\/\s*/g, '-')
      .replace(/\s+/g, '-')
      .replace(/[^a-z0-9-]/g, '')
      .replace(/-+/g, '-')
      .trim();

  return (
    <div className="bg-white px-4 sm:px-6 xl:px-8 py-20 sm:py-[120px]">
      <div className="max-w-[1280px] mx-auto flex flex-wrap justify-center gap-4 md:gap-6 lg:gap-8">
        {categories.map((c) => {
          const slug = slugify(c);
          return (
            <Link
              to={getLocalizedPath(`/paint/${slug}`)}
              key={c}
              className="flex items-center justify-center rounded-[12px] px-4 bg-black h-[54px] text-white inter text-[18px] font-semibold leading-[22px] uppercase"
            >
              {c}
            </Link>
          );
        })}
      </div>
    </div>
  );
};

export default Categories;
